import styled from 'styled-components';

export const $VirtualListContainer = styled.div<{
  $maxHeight?: string;
}>`
  flex: 1;
  min-height: 0;
  max-height: ${({ $maxHeight }) => $maxHeight ?? 'none'};
  overflow: auto;
  width: 100%;
`;

export const $VirtualListInner = styled.div<{
  $height: number;
  $minWidth?: number;
}>`
  width: 100%;
  min-width: ${({ $minWidth }) => ($minWidth ? `${$minWidth}px` : 'auto')};
  position: relative;
  height: ${({ $height }) => $height}px;
`;
